import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { authActions } from '../store/auth-slice';
import useAxios from './use-axios';
import { cmsClient, winnreAuth, winnreNoAuth } from '../utils/axios';
import { useDispatch, useSelector } from 'react-redux';
import { getConfig } from '../utils/config';
import { useRefreshToken } from '.';
import jwtDecode from 'jwt-decode';
import { checkRole, webEngageInit } from '../helpers';
import { decryptData } from '../utils/sec';
import { webViewActions } from '../store/webview';
import { scrollToTargetAdjusted, isInWebView } from '../utils/ui';

const useAppInit = () => {
    const config = getConfig();
    const { loading: tokenLoading, refreshTokenHandler } = useRefreshToken({
        callOnInit: true
    });

    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const queryParams = new URLSearchParams(location.search);
    const jwtToken = useSelector((state) => state.auth.token);
    const unauthorizedUser = useSelector(
        (state) => state.auth.unauthorizedUser
    );
    const unauthorizedUserMessage = useSelector(
        (state) => state.auth.unauthorizedUserMessage
    );

    const webViewAccessToken = queryParams.get('token');
    const webViewRefreshToken = queryParams.get('rhfwetnk');
    const clientToken = queryParams.get('clientToken');
    const isWebView =
        queryParams.get('isWebView') ||
        sessionStorage.isInternalWebView ||
        isInWebView();

    const userToken = queryParams.get('userToken');
    const clientSource = queryParams.get('source');
    const whatsappOptIn = queryParams.get('whatsappOptIn');
    const preLoginWebview = queryParams.get('preLoginWebview');
    const clientWebview = useSelector((state) => state.webView.clientWebview);
    const internalWebview = useSelector(
        (state) => state.webView.internalWebview
    );
    const userWebview = useSelector((state) => state.webView.userWebview);
    const hiddenOnWebview = useSelector(
        (state) => state.webView.hiddenOnWebview
    );
    const scrollTarget = queryParams.get('scrollPosition');

    const {
        loading: loadingWebviewToken,
        refreshTokenHandler: refereshWebviewToken
    } = useRefreshToken({
        callOnInit: false
    });
    const [loading, setLoading] = useState(true);
    const [clientAndUserTokenLoading, setClientAndUserTokenLoading] =
        useState(false);

    const {
        isLoading: loadingUserDetails,
        error: userDetailsError,
        sendRequest: fetchMobileUserDetails
    } = useAxios();

    const headers2 = {
        'content-type': 'application/json;charset=utf-8',
        Authorization: `Bearer ${queryParams.get('token')}`
    };

    function getFaviconEl() {
        return document.getElementById('favicon');
    }

    const loginClientByToken = () => {
        let url;
        setClientAndUserTokenLoading(true);
        if (clientToken) {
            url = `/winnre/login/loginByClientToken?token=${clientToken}${
                isWebView ? '&isWebview=true' : ''
            }`;
        }
        if (userToken) {
            url = `/winnre/login/loginByClientToken?userToken=${userToken}${
                clientSource ? `&source=${clientSource}` : ''
            }${whatsappOptIn ? `&whatsappOptIn=${whatsappOptIn}` : ''}${
                isWebView ? '&isWebview=true' : ''
            }`;
        }
        winnreNoAuth({
            method: 'post',
            url
        })
            .then((res) => {
                // console.log('client', res);
                if (
                    res?.status === 'FAILED' ||
                    res?.status === 'INVALID_TOKEN' ||
                    res?.status === 'UNAUTHORIZED' ||
                    res?.status === 'TOKEN_EXPIRED'
                ) {
                    if (userToken) {
                        // dispatch(authActions.setUnauthorizedUser(res?.message));
                        dispatch(authActions.openLoginModal());
                    } else {
                        dispatch(authActions.openLoginModal());
                    }
                    // setUnauthorizedUserMessage(
                    //     res?.message ||
                    //         'Sorry, we could not identify your identity'
                    // );
                    // setUnauthorizedUser(true);
                } else {
                    // setAuthToken(res?.token);
                    console.log('calling WE login');
                    window?.webengage?.user?.login(res?.user?.hashId);
                    window?.webengage?.user?.setAttribute(
                        'we_email',
                        res?.user?.email
                    );
                    window?.webengage?.user?.setAttribute(
                        'we_phone',
                        res?.user?.mobileNumber
                    );
                    window?.webengage?.user?.setAttribute(
                        'we_first_name',
                        res.user?.name.split(' ')[0]
                    );
                    window?.webengage?.user?.setAttribute(
                        'we_last_name',
                        res.user?.name.split(' ').pop()
                    );
                    window?.webengage?.track('LoggedIn', {
                        ProfileType: `${checkRole(res?.user?.eligibleRoles)}`,
                        ...(isWebView && {
                            Webview: true
                        }),
                        ...(userToken &&
                            !isWebView && {
                                URLLogin: true
                            })
                    });
                    console.log('done calling WE login');

                    dispatch(authActions.authenticationToken(res.accessToken));

                    dispatch(
                        authActions.setUserData({
                            userDetails: {
                                mobileCountryCode: res.user.mobileCountryCode,
                                mobileNumber: res.user.mobileNumber,
                                email: res.user.email,
                                status: res?.user?.cpMaster?.status,
                                preferredName: res?.user?.preferredName,
                                birthDate: res?.user?.dateOfBirth,
                                address: res?.user?.address,
                                companyType: res?.user?.cpMaster?.type
                            },
                            address: res?.user?.address,
                            name: res.user.name,
                            eligibleRoles: res?.user?.eligibleRoles,
                            userRole: checkRole(res?.user?.eligibleRoles),
                            userId: res?.user?.id,
                            hashId: res?.user.hashId,
                            profileCompletionPercentage:
                                res?.user?.profileCompletionPercentage
                        })
                    );
                    dispatch(authActions.login());
                    dispatch(webViewActions.loginWebViewUser());
                    if (config.autoLogout) {
                        sessionStorage.setItem(
                            'refreshToken',
                            res.refreshToken
                        );
                        sessionStorage.setItem('accessToken', res.accessToken);
                    } else {
                        localStorage.setItem('refreshToken', res.refreshToken);
                        localStorage.setItem('accessToken', res.accessToken);
                    }

                    if (
                        queryParams.has('userToken') ||
                        queryParams.has('clientToken')
                    ) {
                        queryParams.delete('userToken');
                        queryParams.delete('clientToken');
                        history.replace({
                            search: queryParams.toString()
                        });
                    }
                }
            })
            .catch((res) => {})
            .finally(() => {
                if (isWebView) {
                    dispatch(webViewActions.activateInternalWebview());
                    sessionStorage.setItem('isInternalWebView', true);
                }
                setClientAndUserTokenLoading(false);
            });
    };

    useEffect(() => {
        if (
            scrollTarget &&
            !(
                loading ||
                tokenLoading ||
                loadingWebviewToken ||
                clientAndUserTokenLoading
            )
        ) {
            scrollToTargetAdjusted(scrollTarget);
        }
    }, [
        scrollTarget,
        loading,
        tokenLoading,
        loadingWebviewToken,
        clientAndUserTokenLoading
    ]);
    useEffect(() => {
        if (sessionStorage.isInternalWebView) {
            dispatch(webViewActions.activateInternalWebview());
        }
    }, []);
    useEffect(() => {
        if (isWebView) {
            dispatch(webViewActions.activateInternalWebview());
        }
    }, [isWebView]);

    useEffect(() => {
        winnreAuth.defaults.headers.common['Authorization'] =
            `Bearer ${jwtToken}`;
    }, [jwtToken]);

    useEffect(() => {
        if (clientToken) {
            dispatch(webViewActions.activateClientWebview());
            loginClientByToken();
        }
    }, [clientToken]);

    useEffect(() => {
        if (preLoginWebview) {
            dispatch(webViewActions.activatePreloginWebview());
        }
    }, [preLoginWebview]);

    useEffect(() => {
        if (userToken) {
            dispatch(webViewActions.activateUserWebview());
            loginClientByToken();
        }
    }, [userToken]);

    useEffect(async () => {
        if (webViewAccessToken) {
            if (
                config.autoLogout
                    ? sessionStorage.accessToken && sessionStorage.refreshToken
                    : localStorage.accessToken && localStorage.refreshToken
            ) {
                const decryptedWebviewToken =
                    await decryptData(webViewAccessToken);
                const decryptedLocalToken = await decryptData(
                    config.autoLogout
                        ? sessionStorage.accessToken
                        : localStorage.accessToken
                );
                const decodedWebviewToken = jwtDecode(decryptedWebviewToken);
                const decodedLocalToken = jwtDecode(decryptedLocalToken);
                //.exp is the time at which token expires
                // console.log(decodedWebviewToken.exp, decodedLocalToken.exp);
                if (decodedWebviewToken.exp < decodedLocalToken.exp) {
                    // console.log('Webview will expire sooner');
                    refereshWebviewToken(
                        false,
                        config.autoLogout
                            ? sessionStorage.accessToken
                            : localStorage.accessToken,
                        config.autoLogout
                            ? sessionStorage.refreshToken
                            : localStorage.refreshToken
                    );
                } else {
                    // console.log('Local will expire sooner');

                    refereshWebviewToken(
                        false,
                        webViewAccessToken,
                        webViewRefreshToken
                    );
                }
            } else {
                // console.log(
                //     'TOKEN NOT IN LS',
                //     webViewAccessToken,
                //     webViewRefreshToken
                // );
                refereshWebviewToken(
                    false,
                    webViewAccessToken,
                    webViewRefreshToken
                );
            }
            dispatch(webViewActions.activateInternalWebview());
            // getMobileUserDetailsAndAuthenticate();
            // dispatch(authActions.authenticationToken(webViewAccessToken));
        }
    }, [webViewAccessToken]);

    useEffect(() => {
        const htmlTag = document.getElementsByTagName('html');
        htmlTag[0].setAttribute('data-theme', `${config.theme}`);

        document.title = window.reloy_env.TITLE_NAME;

        const favicon = getFaviconEl();
        favicon.href = `${config?.favicon}`;
        console.log('favicon.href', favicon.href);
        setLoading(false);
    }, []);

    useEffect(() => {
        /*   if (
            cmsClient.defaults.baseURL === 'https://dev.loyalie.in' &&
            config?.devWebengageLic
        ) {
            webEngageInit(config?.devWebengageLic);
        } else if (
            cmsClient.defaults.baseURL === 'https://uat.loyalie.in' &&
            config?.uatWebengageLic
        ) {
            webEngageInit(config?.uatWebengageLic);
        } else if (
            cmsClient.defaults.baseURL === 'https://prod.loyalie.in' &&
            config?.webengageLic
        ) {
            webEngageInit(config?.webengageLic);
        } */
    }, []);

    useEffect(() => {
        const refreshInterval = setInterval(
            () => refreshTokenHandler(true),
            10000 * 60
        );
        return () => clearInterval(refreshInterval);
    }, []);

    const refreshOnNoActivity = () => {
        // console.log('refreshing on no activity');
        refreshTokenHandler(true, null, null, true);
    };

    return {
        loading,
        config,
        loadingWebviewToken,
        tokenLoading,
        unauthorizedUser,
        unauthorizedUserMessage,
        clientWebview,
        userWebview,
        internalWebview,
        hiddenOnWebview,
        preLoginWebview,
        refreshOnNoActivity,
        clientAndUserTokenLoading
    };
};

export default useAppInit;
